import { Themes } from './types';

// eslint-disable-next-line import/prefer-default-export
export const themes: Themes = {
  default: {
    headerBg: { hex: '#2b2d3c', rgb: [43, 45, 60] },
    mainBg: { hex: '#f1f1f3', rgb: [241, 241, 243] },
    primary: { hex: '#b6509e', rgb: [182, 80, 158] },
    secondary: { hex: '#2ebac6', rgb: [46, 186, 198] },
    darkBlue: { hex: '#383d51', rgb: [56, 61, 81] },
    textDarkBlue: { hex: '#383d51', rgb: [56, 61, 81] },
    lightBlue: { hex: '#8d8f99', rgb: [141, 143, 153] },
    red: { hex: '#de5959', rgb: [222, 89, 89] },
    orange: { hex: '#ffac4d', rgb: [255, 172, 77] },
    green: { hex: '#79c982', rgb: [121, 201, 130] },
    white: { hex: '#ffffff', rgb: [255, 255, 255] },
    whiteElement: { hex: '#ffffff', rgb: [255, 255, 255] },
    whiteItem: { hex: '#ffffff', rgb: [255, 255, 255] },
    darkOrange: { hex: '#f0650a', rgb: [240, 101, 10] }, // for deposit APY
    gray: { hex: '#707070', rgb: [112, 112, 112] },
    lightGray: { hex: '#a2a2a2', rgb: [162, 162, 162] },
    disabledGray: { hex: '#e0e0e2', rgb: [224, 224, 226] },
  },
  dark: {
    headerBg: { hex: '#20202e', rgb: [32, 32, 46] },
    mainBg: { hex: '#2b2d3c', rgb: [43, 45, 60] },
    primary: { hex: '#b6509e', rgb: [182, 80, 158] },
    secondary: { hex: '#2ebac6', rgb: [46, 186, 198] },
    darkBlue: { hex: '#383d51', rgb: [56, 61, 81] },
    textDarkBlue: { hex: '#f1f1f3', rgb: [241, 241, 243] },
    lightBlue: { hex: '#8d8f99', rgb: [141, 143, 153] },
    red: { hex: '#de5959', rgb: [222, 89, 89] },
    orange: { hex: '#ffac4d', rgb: [255, 172, 77] },
    green: { hex: '#79c982', rgb: [121, 201, 130] },
    white: { hex: '#f1f1f3', rgb: [241, 241, 243] },
    whiteElement: { hex: '#383d51', rgb: [56, 61, 81] },
    whiteItem: { hex: '#2b2d3c', rgb: [43, 45, 60] },
    darkOrange: { hex: '#f0650a', rgb: [240, 101, 10] }, // for deposit APY
    gray: { hex: '#707070', rgb: [112, 112, 112] },
    lightGray: { hex: '#a2a2a2', rgb: [162, 162, 162] },
    disabledGray: { hex: '#20202e', rgb: [32, 32, 46] },
  },
};
